(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var BaseModel = require('cf-base-model')
  , schemata = require('../../../service/office/schema')({}, {})

module.exports = BaseModel.extend(
  { idAttribute: '_id'
  , schemata: schemata
  , defaults: function () {
      return schemata.makeDefault()
    }
  , url: function () {
      var url = window.config.apiUrl + '/office'
      if (this.id) {
        url += '/' + this.id
      }
      return url
    }
  })


}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/admin/office/models/office.js","/components/admin/office/models")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbXBvbmVudHMvYWRtaW4vb2ZmaWNlL21vZGVscy9vZmZpY2UuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBIiwiZmlsZSI6ImdlbmVyYXRlZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzQ29udGVudCI6WyJ2YXIgQmFzZU1vZGVsID0gcmVxdWlyZSgnY2YtYmFzZS1tb2RlbCcpXG4gICwgc2NoZW1hdGEgPSByZXF1aXJlKCcuLi8uLi8uLi9zZXJ2aWNlL29mZmljZS9zY2hlbWEnKSh7fSwge30pXG5cbm1vZHVsZS5leHBvcnRzID0gQmFzZU1vZGVsLmV4dGVuZChcbiAgeyBpZEF0dHJpYnV0ZTogJ19pZCdcbiAgLCBzY2hlbWF0YTogc2NoZW1hdGFcbiAgLCBkZWZhdWx0czogZnVuY3Rpb24gKCkge1xuICAgICAgcmV0dXJuIHNjaGVtYXRhLm1ha2VEZWZhdWx0KClcbiAgICB9XG4gICwgdXJsOiBmdW5jdGlvbiAoKSB7XG4gICAgICB2YXIgdXJsID0gd2luZG93LmNvbmZpZy5hcGlVcmwgKyAnL29mZmljZSdcbiAgICAgIGlmICh0aGlzLmlkKSB7XG4gICAgICAgIHVybCArPSAnLycgKyB0aGlzLmlkXG4gICAgICB9XG4gICAgICByZXR1cm4gdXJsXG4gICAgfVxuICB9KVxuXG4iXX0=